module.exports = "/_next/static/images/DataDrivenReport-f964c241118ae2f37e6c6ee7e02bcdc7.webp";